import { getRequestAuthPayload } from '@helpers/getRequestAuth';
import type { AuditEntry } from '@root/@types/audit-log';
import type { ServerResponse } from '@root/@types/types';
import { queryOptions } from '@tanstack/react-query';
import axios from 'axios';

import type { QueryFactory } from './factory.types';

export const fetchBlockAudit = async (id: string): Promise<ServerResponse<AuditEntry[]>> => {
  const networkPayload = await getRequestAuthPayload({
    method: 'get',
    url: `blocks/${id}/audit`,
  });

  const response = await axios(networkPayload);
  return response.data;
};

export const blockAuditQueries = {
  // `version` (the block's updated_at) is in the key so a save becomes a new query —
  // React Query refetches automatically without polling, mirroring entityQueries.auditLog.
  forBlock: (id: string, version?: string) =>
    queryOptions({
      queryKey: ['block-audit', id, version] as const,
      queryFn: () => fetchBlockAudit(id),
    }),
} satisfies QueryFactory;
